<template>
  <div class="BaseHead-container">
    <div class="gb-wrap clearfix">
      <div class="my-titlewrap">
        <a class="head-img" href="/" @click.prevent="$router.push('/')">
          <img alt="木夕logo" src="@/assets/logo.png" />
        </a>
        <span class="my-title">| 重置密码</span>
      </div>
      <!-- <div class="head-info">
        <div class="head-info-group" v-if="hasLogin">
          <img class="head-info-icon my-crystal-icon" src="@/assets/crytal_blue.png">
          <p class="ut-fl">当前水晶：{{crystalNum}}</p>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BaseHead',
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapState(['vx_userInfo']),
    hasLogin() {
      return !!this.vx_userInfo
    },
    crystalNum() {
      return (this.vx_userInfo || {}).crystalNum
    }
  },
  created() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.BaseHead-container {
  height: 100px;
  background: #fff;
  color: #333333;
  font-size: 12px;
  // overflow: hidden;
}

.gb-wrap {
  padding-top: 30px;
}

.my-titlewrap {
  float: left;
  line-height: 40px;
  font-size: 23px;
  color: #979797;
}

.my-title {
  margin-left: 10px;
}

.head-img {
  float: left;
  height: 40px;
  cursor: pointer;
  img {
    height: 100%;
  }
}

.head-info {
  float: right;
  padding-top: 20px;
  line-height: 20px;
}

.my-tick {
  position: absolute;
  // top: 2px;
  width: 20px;
  text-align: center;
  transform: rotate(180deg);
}

.head-info-group {
  position: relative;
  float: left;
}

.head-info-icon {
  float: left;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  &.my-crystal-icon {
    width: 15px;
    height: 15px;
    margin-top: 3px;
    margin-right: 5px;
  }
}
</style>
